/**
 * check localStorage to see if user is authenticated by looking at
 * 1. whether access_token exists
 * 2. whether access_token_expire_time is after current time
 */

import moment from 'moment';

export default function isAuthenticated(localStorage = window.localStorage) {
  const token = localStorage.getItem('access_token');
  const expTime = localStorage.getItem('access_token_expire_time');

  if (!token || !expTime) {
    return false;
  }

  // token exits; check if token is expired
  return moment().isBefore(moment(parseInt(expTime, 10)).format('YYYY-MM-DD HH:mm:ss'));
}



// WEBPACK FOOTER //
// ./src/toolbox/isAuthenticated.js